// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__r6T40","title":"card_title__9Hpbx","inActive":"card_inActive__dVXhJ"};